export default __webpack_public_path__ + "static/media/connection.64e18d61.svg";